import styled from 'styled-components';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';

export const CardContainer = styled(Card)`
  width: 345px;
  height: 345px;
  margin: 10px;
`;

export const CardMediaStyled = styled(CardMedia)`
  height: 140px;
`;
